<template>
  <div class="step" :class="{ 'step_active': active }">
    <div class="step__inner">
      <h3 class="step__title">Заполните данные заявителя</h3>
      <TextInput @setError="errors.name = $event" v-model="form.applicant.name" text="ФИО заявителя" name="applicant-name"/>
      <DateInput @setError="errors.birthdate = $event" name="applicant-birthdate" text="Дата рождения заявителя" :range="false" v-model="form.applicant.birthdate" />
      <SelInput text="Документ удостоверяющий личность" name="applicant-doctype" :options="doctypes" v-model="form.applicant.doc.type" />
      <ShortFields>
        <NumberInput v-if="dynamicfields.series" mask="####" @setError="errors.series = $event" :filled="(v)=>v.length == 4" v-model="form.applicant.doc.series" text="Серия документа" name="applicant-doc-series"/>
        <NumberInput v-if="dynamicfields.number" mask="######" @setError="errors.number = $event" :filled="(v)=>v.length == 6" v-model="form.applicant.doc.number" text="Номер документа" name="applicant-doc-number"/>
        <TextInput v-if="dynamicfields.foreignnumber" @setError="errors.number  = $event" v-model="form.applicant.doc.number" text="Номер документа" name="applicant-doc-foreign-number"/>
      </ShortFields>
      <ShortFields>
        <NumberInput v-if="dynamicfields.code" mask="###-###" @setError="errors.code = $event" :filled="(v)=>v.length == 7" v-model="form.applicant.doc.code" text="Код подразделения " name="applicant-doc-code"/>
        <DateInput v-if="dynamicfields.releasedate" @setError="errors.releasedate = $event" v-model="form.applicant.doc.releasedate" text="Дата выдачи документа" name="applicant-doc-releasedate"/>
      </ShortFields>
      <Btn class="step__next" :disabled="!filled" @click="$store.commit('nextStep')">Далее</Btn>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import TextInput from '@/components/inputs/TextInput.vue';
import Btn from '../Btn.vue';
import DateInput from '../inputs/DateInput.vue';
import SelInput from '../inputs/SelInput.vue';
import ShortFields from '../ShortFields.vue';
import NumberInput from '../inputs/NumberInput.vue';
export default {
  components: { TextInput, DateInput, Btn, SelInput, ShortFields, NumberInput },
  data: ()=>({
    errors: { },
    doctypes: ['','Паспорт гражданина РФ','Паспорт иностранного гражданина','Иное'],
    dynamicfields: {
      series: false,
      number: false,
      foreignnumber: false,
      code: false,
      releasedate: false
    }
  }),
  props: {
    active: { type: Boolean }
  },
  computed: {
    ...mapState(['form']),
    ...mapGetters(['contractCount']),
    filled() {
      for (let key in this.errors)
        if (this.errors[key]) return false
      if (!this.form.applicant.name || !this.form.applicant.birthdate || !this.form.applicant.doc.type) 
        return false
      let required = []
      for (let key in this.dynamicfields)
        if (this.dynamicfields[key])
          if (key == 'foreignnumber')
            required.push('number')
          else
            required.push(key)
      for (let key of required)
        if (!this.form.applicant.doc[key]) return false
      return true
    },
  },
  methods: {
    clearFields(){
      this.form.applicant.doc.number = ''
      this.form.applicant.doc.series = ''
      this.form.applicant.doc.code = ''
      this.form.applicant.doc.releasedate = ''
    },
    setDynamicFields(doctypeindex) {
      switch (doctypeindex) {
        case 1:
          return this.dynamicfields = {
            series: true,
            number: true,
            foreignnumber: false,
            code: true,
            releasedate: true
          }
        case 2:
          return this.dynamicfields = {
            series: false,
            number: false,
            foreignnumber: true,
            code: false,
            releasedate: true
          }          
        case 0:
        case 3:
          return this.dynamicfields = {
            series: false,
            number: false,
            foreignnumber: false,
            code: false,
            releasedate: false
          }          
      }
    }
  },
  watch: {
    'form.applicant.doc.type': function(value, old) {
      if (value != old)
        this.clearFields()
      for (let i = 0; i < this.doctypes.length; i++)
        if (value == this.doctypes[i])
          return this.setDynamicFields(i)
    }
  }
}
</script>

<style lang="sass">

</style>